import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SessionExpiredModal = ({ onClose }) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  // Auto-redirect after 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleGoToLogin();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleGoToLogin = () => {
    if (onClose) onClose();
    navigate('/login', { replace: true });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          {/* Icon */}
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-yellow-100">
            <svg
              className="w-6 h-6 text-yellow-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          {/* Title */}
          <h2 className="text-xl font-semibold text-center text-gray-900 mb-2">
            Session Expired
          </h2>

          {/* Message */}
          <p className="text-center text-gray-600 mb-2">
            Your session has expired for security reasons. Please log in again to continue.
          </p>
          <p className="text-center text-sm text-gray-500 mb-6">
            Redirecting to login in <span className="font-semibold text-blue-600">{countdown}</span> seconds...
          </p>

          {/* Button */}
          <button
            onClick={handleGoToLogin}
            className="w-full px-4 py-2 text-white bg-blue-600 hover:bg-blue-700 rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Go to Login Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
